import SuspendedButton from '../SuspendedButton';
import { IStep2Props, IProductItem } from '../cacl';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
export default function Step2({ productList, solarTypeList, setSelectInfo, selectInfo }: IStep2Props) {
    const { useEffect, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const router = useRouter();
    const { locale } = router;

    const chargTimeList = [2, 3, 4, 5, 6, 7, 8, 9];
    const setActiveChargeTime = (index: number) => {
        if (selectInfo.chargTime === index) return;
        setSelectInfo({ ...selectInfo, chargTime: index });
    };
    const setActiveSolarTime = (type: string) => {
        if (selectInfo.solarType === type) return;
        setSelectInfo({ ...selectInfo, solarType: type, activeStep: 3 });
    };
    const goBack = () => {
        router.push({
            pathname: `/${locale}/calculators/solarpanels`,
        });
    };
    const goStep3 = () => {
        if (!selectInfo.solarType) return;
        setSelectInfo({
            ...selectInfo,
            activeStep: 4,
        });
        /** 埋点  --start */
        const option_name1 = solarTypeList.find((item) => item.type === selectInfo.solarType)?.text;
        const allProducts = productList.reduce<IProductItem[]>((p, c) => p.concat(c.list), []);
        const product_name = allProducts.find((item) => item.key === selectInfo.productkey)?.productName;
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator2_solar_panels',
            step: 'charging time&type',
            button_name: t('cacl_step2_next_btn'),
            product_name: product_name,
            list_name: 'none',
            option_name: `${selectInfo.chargTime}hrs`,
            option_name1: option_name1 || '',
        });
        /** 埋点 --end */
        router.push({
            pathname: `/${locale}/calculators/solarpanels`,
            query: {
                step: 3,
            },
        });
    };
    useEffect(() => {
        const { productkey } = selectInfo;
        if (!productkey) goBack();
    }, []);

    return (
        <div className={css.step2}>
            <h3 className="calc-solar-step2-title-1">{t('cacl_step2_select_recharge_title')}</h3>
            <div className="charg-time-container">
                <div className="charg-time-wrapper">
                    <div className="charg-time-content">
                        {chargTimeList.map((chargTime) => (
                            <div
                                key={chargTime}
                                className={`${selectInfo.chargTime === chargTime ? 'active' : ''} chargTimeItem font-family-semibold`}
                                onClick={() => setActiveChargeTime(chargTime)}
                            >
                                {chargTime}
                                {t('cacl_step2_recharge_time_unit')}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="tooltip font-family-semibold">
                    <span className="text">Short Time</span>
                    <span className="text">Long Time</span>
                </div>
            </div>

            <h3 className="calc-solar-step2-title-2">{t('cacl_step2_select_type_title')}</h3>
            <div className="solar-type-list">
                {solarTypeList.map((solarType, index) => (
                    <div
                        key={index}
                        className={`solar-type-item ${selectInfo.solarType === solarType.type ? 'active' : ''}`}
                        onClick={() => setActiveSolarTime(solarType.type)}
                    >
                        <span className="icon">{solarType.icon}</span>
                        <span className="text font-family-semibold">{solarType.text}</span>
                    </div>
                ))}
            </div>
            <SuspendedButton goBack={goBack} goNext={goStep3} disabledNextBtn={!selectInfo.solarType} />
        </div>
    );
}
